import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy';

function Home() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToFeatures = () => {
    document.getElementById('features').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="app">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/" className="logo-link">
              <img src="/images/panchangam-icon.png" alt="Panchangam" className="logo-icon" />
              <span className="logo-text">Panchangam</span>
            </Link>
          </div>
          <div className="nav-links">
            <a href="#features" onClick={scrollToFeatures}>Features</a>
            <a href="https://play.google.com/store/apps/details?id=io.expo.panchangam" target="_blank" rel="noopener noreferrer" className="cta-button">
              Download
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className={`hero-title ${isVisible ? 'fade-in' : ''}`}>
              Daily Hindu Panchang
            </h1>
            <p className={`hero-subtitle ${isVisible ? 'fade-in' : ''}`}>
              Get accurate daily panchang with Tithi, Nakshatra, Yoga, Karana, and Varra. 
              Track sun and moon timings, find auspicious timings, and discover Hindu festivals for your location.
            </p>
            <div className={`hero-buttons ${isVisible ? 'fade-in' : ''}`}>
              <a 
                href="https://play.google.com/store/apps/details?id=io.expo.panchangam" 
                target="_blank" 
                rel="noopener noreferrer"
                className="download-button"
              >
                <svg className="play-store-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                Get it on Google Play
              </a>
              <button onClick={scrollToFeatures} className="learn-more-button">
                Learn More
              </button>
            </div>
          </div>
          <div className={`hero-image ${isVisible ? 'slide-in' : ''}`}>
            <img src="/images/Screenshot_festival.png" alt="Panchangam App" className="hero-app-image" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="features-container">
          <h2 className="section-title">Perfect for daily spiritual practices</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📍</div>
              <h3>Location Based Panchang</h3>
              <p>Get accurate panchang calculations based on your current location for precise astrological information</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">☀️🌙</div>
              <h3>Sun & Moon Times</h3>
              <p>Track daily sunrise, sunset, moonrise, and moonset timings for your location</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⏰</div>
              <h3>Auspicious Timings</h3>
              <p>Find the best times for prayers and important activities with Rahu Kalam and Amrit Kalam</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎉</div>
              <h3>Hindu Festivals</h3>
              <p>Discover and track important Hindu festivals and celebrations throughout the year</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>Easy Sharing</h3>
              <p>Share daily panchang details and auspicious timings with friends and family via screenshots</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📅</div>
              <h3>Calendar Integration</h3>
              <p>Add important dates and auspicious timings directly to your native calendar</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2>Start your spiritual journey today</h2>
          <p>Join thousands of users who rely on Panchangam for their daily spiritual practices</p>
          <a 
            href="https://play.google.com/store/apps/details?id=io.expo.panchangam" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cta-download-button"
          >
            <svg className="play-store-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            Download on Google Play
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/images/panchangam-icon.png" alt="Panchangam" className="footer-logo-icon" />
                <span className="logo-text">Panchangam</span>
              </div>
              <p>A Hindu calendar with daily sun and moon timings, tithis, nakshatra, yoga, karana and rashi based on Amanta and Saka Samvat calendar.</p>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>feedback.innings@gmail.com</p>
            </div>
            <div className="footer-section">
              <h4>Links</h4>
              <a href="https://play.google.com/store/apps/details?id=io.expo.panchangam" target="_blank" rel="noopener noreferrer">Google Play Store</a>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <a href="#" onClick={(e) => e.preventDefault()}>Terms of Service</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Panchangam. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
